/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: branding-media-edit-view-break-prepostroll-component.ts
 *
 * Created by kyang on 10/29/20.
 */

function BrandingMediaEditViewBreakPrePostRollController(
    this: JS5Object,
) {

    //===========================//
    // PreRoll Template Response //
    //===========================//

    this.addPreRollAudio = () => {
        this.breakPrePostRoll.preRoll.audios.push({});
        this.editorForm.$setDirty();
    };

    this.removePreRollAudio = (audioIndex: number) => {
        this.breakPrePostRoll.preRoll.audios.splice(audioIndex, 1);
        this.editorForm.$setDirty();
    };

    this.addPreRollText = () => {
        this.breakPrePostRoll.preRoll.texts.push({});
        this.editorForm.$setDirty();
    };

    this.removePreRollText = (textIndex: number) => {
        this.breakPrePostRoll.preRoll.texts.splice(textIndex, 1);
        this.editorForm.$setDirty();
    };


    //============================//
    // PostRoll Template Response //
    //============================//

    this.addPostRollAudio = () => {
        this.breakPrePostRoll.postRoll.audios.push({});
        this.editorForm.$setDirty();
    };

    this.removePostRollAudio = (audioIndex: number) => {
        this.breakPrePostRoll.postRoll.audios.splice(audioIndex, 1);
        this.editorForm.$setDirty();
    };

    this.addPostRollText = () => {
        this.breakPrePostRoll.postRoll.texts.push({});
        this.editorForm.$setDirty();
    };

    this.removePostRollText = (textIndex: number) => {
        this.breakPrePostRoll.postRoll.texts.splice(textIndex, 1);
        this.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.containerType = 'breakPrePostRolls';
    };
}

angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditViewBreakPrePostRoll', {
        templateUrl: 'components/branding/editView/components/media/editView/components/breakPrePostRoll/branding-media-edit-view-break-prepostroll-template.html',
        controller: BrandingMediaEditViewBreakPrePostRollController,
        bindings: {
            breakPrePostRoll: '<',
            availableLanguages: '<',
            availableTerritories: '<',
            availableAudioAcceptProfiles: '<',
            availableAudioRoles: '<',
            availableTextRoles: '<',
        }
    });
